<template>
  <!-- <a :href="loginUrl" class="nav-item"> -->
    <router-link :to="{ name: 'Closed Registration' }">
      <Button
        :class="{ 'tall-cta': tall }"
        :type="type"
        :href="loginUrl">{{ title }}
        <Icon v-if="arrow" type="arrow-right-c"></Icon>
      </Button>
    </router-link>
  <!-- </a> -->
</template>
<script type="text/javascript">
export default {
  props: {
    type: { type: String, default: 'primary' },
    arrow: { type: Boolean, default: false },
    title: { type: String, default: 'Get Started' },
    tall: { type: Boolean, default: false },
  },
  data() {
    return { loginUrl: process.env.LOGIN_URL };
  },
};
</script>
<style lang="css" scoped>
.tall-cta {
  /* 67 rather than an even num. because the text will fall in the center (when the dev. console is not open) */
  height: 37px;
  font-size: 14px;
  padding: 0px 18px;
}

.green {
  background: #00cc66;
  border-color: #00cc66;
}

/* Can seem to target the span inside... */
/*.tall-cta span {
  font-weight: bold;
}*/
</style>


// WEBPACK FOOTER //
// src/components/GetStartedButton.vue